import { makeStyles } from "@mui/styles"

export const useIconOverrides = makeStyles({
  root: {
    minWidth: 42,
  },
})
